import { TWeight } from '@honeybook/hbui/dist/components/HBText/HBText.types';
import { TCustomFont } from '@honeybook/hbui/dist/styles/fonts';
import { IImage } from '~/types/model.types';

export interface IGenericConfig {
    version: string;
    contact_form: {
        current_app_entry_point: string;
        recaptch_key: string;
        recaptch_key_v3: string;
        base_api_url: string;
        validate_email_endpoint: string;
        submit_inquiry_endpoint: string;
    };
    scheduler: {
        current_app_entry_point: string;
        recaptch_key: string;
        recaptch_key_v3: string;
        base_api_url: string;
        validate_email_endpoint: string;
        submit_inquiry_endpoint: string;
    };
}

export interface ICompanyBrandingData {
    company_id?: string;
    title?: string;
    logo_url?: string;
    icon?: Pick<
        IImage,
        | 'url'
        | 'cloudinary_public_id'
        | 'position_x'
        | 'position_y'
        | 'position_w'
        | 'position_h'
    >;
    brand_color?: string;
    text_color?: string;
    website_url?: string;
    schema_version?: number;
}

export interface IUserBrandingData {
    full_name: string;
    job_title: string;
}

export interface IClientMinimalData {
    email: string;
    client_2fa_sms_enabled?: boolean;
    phone?: string;
}

export interface ISelector {
    selector: string;
    selector_type: string;
}

export interface IClientExperienceCompany {
    _id: string;
    brand_color: string;
    text_color: string;
    owner: { _id: string };
}

export interface IContactFormSettings {
    _id: string;
    display_header_for_direct_link: boolean;
    is_active: boolean;
    project_type: string;
    redirect_type: string;
    redirect_url: string;
    spam_protection_type: string;
}

export interface IContactForm {
    _id: string;
    base_api_url: string;
    contact_form_flow_type: string;
    contact_form_settings: IContactFormSettings;
    data_model: string;
    env: string;
    file_dynamic_content: any;
    last_publish_timestamp: string;
    mode: string;
    vendor_id_for_inquiries: string;
    version: number;
}

export interface IUserConfig {
    placement_id: string;
    data_version: Number;
    schema_version: Number;
    selectors: {
        [id: string]: ISelector;
    };
    company: IClientExperienceCompany;
    contact_forms: [IContactForm];
}

export interface IStickyHeaderState {
    showStickyHeader: boolean;
    text: string;
    isDisabled: boolean;
    isSticky?: boolean;
    formStyleContainer: IContactFormStyles;
}

export enum ContactFormEvents {
    ContactFormMounted = 'hb_contact_form_mounted',
    ContactFormScrolled = 'hb_contact_form_scrolled',
    ContactFormReset = 'hb_contact_form_preview_reset',
    PaymentTokenReceived = 'hb_payment_token_received',
    StickyHeaderStateReceived = 'hb_contact_form_button_state',
    CheckoutPreviewDataReceived = 'hb_checkout_preview_data_received',
    ContactFormStaleError = 'hb_stale_contact_form_error'
}

export interface IContactFormMountedEventData {
    type: ContactFormEvents.ContactFormMounted;
    contact_form_id: string;
}

export interface IContactFormPaymentTokenEventData {
    type: ContactFormEvents.PaymentTokenReceived;
    hb_token: string;
}

export interface IContactFormStickyHeaderEventData {
    type: ContactFormEvents.StickyHeaderStateReceived;
    data: IStickyHeaderState;
}

export interface IContactFormScrolledEventData {
    type: ContactFormEvents.ContactFormScrolled;
    pageYOffset: number;
}

export interface IContactFormResetData {
    type: ContactFormEvents.ContactFormReset;
}

export interface ICheckoutPreviewDataReceivedData {
    type: ContactFormEvents.CheckoutPreviewDataReceived;
    data: any;
}

export interface IContactFormStaleData {
    type: ContactFormEvents.ContactFormStaleError;
    data: any;
}

export interface IContactFormEvent {
    data: {
        hbEvent:
            | IContactFormMountedEventData
            | IContactFormPaymentTokenEventData
            | IContactFormStickyHeaderEventData
            | IContactFormScrolledEventData
            | IContactFormResetData
            | ICheckoutPreviewDataReceivedData
            | IContactFormStaleData;
    };
}

export interface IContactFormStyleContainer {
    _id: string;
    font_type: string;
    font_family: TCustomFont;
    font_url: string;
    font_color: string;
    font_size: string;
    font_weight: TWeight;
    border_color: string;
    background_color: string;
}

export interface IContactFormStyles {
    form_component_style: IContactFormStyleContainer;
    button_component_style: IContactFormStyleContainer;
    global_style: IContactFormStyleContainer;
}

export enum ClientExperienceMode {
    PreviewDraft = 'PREVIEW_DRAFT',
    PreviewActive = 'PREVIEW_ACTIVE',
    PreviewVersionHistory = 'PREVIEW_OLD_REVISION',
    Production = 'PRODUCTION'
}
